export enum RejectionType {
  RecommendationApplied = 'RecommendationApplied',
  NotQualified = 'NotQualified',
}
